/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUserTilesRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {GetUserTilesResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const getUserTiles = (request: GetUserTilesRequest, options?: CashRequestOptions) => post<GetUserTilesRequest, GetUserTilesResponse>("/2.0/cash/get-user-tiles", request, {...options, rejectOnError: true })